import { type TokenGroup } from "../../types";

export const grass = {
  name: "grass",
  variables: {
    "1": { type: "color", value: { dark: "#0d1912", light: "#fbfefb" } },
    "2": { type: "color", value: { dark: "#0f1e13", light: "#f3fcf3" } },
    "3": { type: "color", value: { dark: "#132819", light: "#ebf9eb" } },
    "4": { type: "color", value: { dark: "#16301d", light: "#dff3df" } },
    "5": { type: "color", value: { dark: "#193921", light: "#ceebcf" } },
    "6": { type: "color", value: { dark: "#1d4427", light: "#b7dfba" } },
    "7": { type: "color", value: { dark: "#245530", light: "#97cf9c" } },
    "8": { type: "color", value: { dark: "#2f6e3b", light: "#65ba75" } },
    "9": { type: "color", value: { dark: "#46a758", light: "#46a758" } },
    "10": { type: "color", value: { dark: "#55b467", light: "#3d9a50" } },
    "11": { type: "color", value: { dark: "#63c174", light: "#297c3b" } },
    "12": { type: "color", value: { dark: "#e5fbeb", light: "#1b311e" } },
  },
} as const satisfies TokenGroup<"grass">;
